import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../tailwind-site.config.js'

const config = resolveConfig(tailwindConfig)

export const lockScroll = () => {
  $('body').css({overflowY: 'hidden'})
};

export const unlockScroll = () => {
  $('body').css({overflowY: ''})
};

export const remToPixels = (rem) => {
    if (typeof rem === 'string') {
        rem = parseFloat(rem.replace('rem', ''));
    }
    return (
        rem * (
            parseFloat(
                getComputedStyle(document.documentElement).fontSize
            )
        )
    );
};

export const breakpoints = (() => (
    Object.keys(config.theme.screens).reduce(
        (breakpoints, breakpoint) => ({
            ...breakpoints,
            [breakpoint]: (
                remToPixels(
                    config.theme.screens[breakpoint]
                )
            )
        }),
        {}
    )
))();

export const colors = config.theme.colors;

export const debounce = (func, wait) => {
  let timeout = null;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(
      () => func.apply(context, args),
      wait
    );
  };
};

export const throttle = (func, delay) => {
    let timeout = null;
    return (...args) => {
        if(timeout) return;
        func(...args);
        timeout = setTimeout(
            () => timeout = null,
            delay
        );
    };
};

export const scrollTo = ($element, options = {}) => {
    $('html').get(0).scrollTo({
        top: (
            $element.offset().top
            - (
              (options.accountForHeader ?? true)
                ? $('[data-header]').outerHeight()
                : 0
            )
            - (options.offset ?? 0)
        ),
        behavior: options.behavior ?? 'smooth',
    });
};

